/* albm-coupon.js — <albm-coupon-button> + <albm-coupon-modal> · OWNER: T0
   Nút nổi xoay −90° mép phải mở modal danh sách offer. Esc đóng, khoá scroll, trả focus.
*/
class AlbmCouponButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', () => {
      const id = this.getAttribute('for');
      const modal = id ? document.getElementById(id) : document.querySelector('albm-coupon-modal');
      modal?.open(this.button);
    });
  }
}

class AlbmCouponModal extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('[data-albm-coupon-panel]');
    this.querySelectorAll('[data-albm-coupon-close]').forEach((el) =>
      el.addEventListener('click', () => this.close())
    );
    this.onKeydown = this.onKeydown.bind(this);
    this.setAttribute('aria-hidden', 'true');
  }

  open(opener) {
    this.opener = opener || null;
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    document.addEventListener('keydown', this.onKeydown);
    if (typeof window.trapFocus === 'function' && this.panel) {
      window.trapFocus(this.panel, this.querySelector('[data-albm-coupon-close]'));
    }
  }

  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('keydown', this.onKeydown);
    if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus(this.opener);
    else this.opener?.focus();
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.close();
  }
}

if (!customElements.get('albm-coupon-button')) {
  customElements.define('albm-coupon-button', AlbmCouponButton);
}
if (!customElements.get('albm-coupon-modal')) {
  customElements.define('albm-coupon-modal', AlbmCouponModal);
}
